import { organisationConstants } from '../../../_constants';

const initial_holder_list_and_organisation_competency = {
    holder_list: [],
    organisation_compitency_metric_list: []
}

const initialState = {
    holder_list_and_organisation_competency_loading: true,
    holder_list_and_organisation_competency: { ...initial_holder_list_and_organisation_competency },
    holder_list_and_organisation_competency_error: false, 
    holder_list_and_organisation_competency_error_data: {}
};

export function getHolderAndOrganisationCompetency(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY:
            return {
                holder_list_and_organisation_competency_loading: true,
                holder_list_and_organisation_competency: { ...initial_holder_list_and_organisation_competency },
                holder_list_and_organisation_competency_error: false,
                holder_list_and_organisation_competency_error_data: {}
            };
        case organisationConstants.RECEIVE_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY:
            return {
                holder_list_and_organisation_competency_loading: false,
                holder_list_and_organisation_competency: action.holder_list_and_organisation_competency,
                holder_list_and_organisation_competency_error: false,
                holder_list_and_organisation_competency_error_data: {}
            };
        case organisationConstants.GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY_ERROR:
            return {
                holder_list_and_organisation_competency_loading: false,
                holder_list_and_organisation_competency: { ...initial_holder_list_and_organisation_competency },
                holder_list_and_organisation_competency_error: true,
                holder_list_and_organisation_competency_error_data: action.holder_list_and_organisation_competency_error_data
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/roleFitmentReport/getHolderAndOrganisationCompetency.reducer.js